import apiClient from "../utils/ApiClient/apiClientAxios";



export const importService = {
  // ─────────────────────────────
  // STEP 1: Upload file
  // ─────────────────────────────
  uploadRoster: async (file) => {
    console.log("Uploading file:", file);


    const response = await fetch(
      `/api/uploadRoster?blob_name=${encodeURIComponent(file.name)}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/octet-stream",
        },
        body: file,
      },
    );

    if (!response.ok) {
      throw new Error(`uploadRoster failed: ${response.statusText}`);
    }
    return await response.json();
  },

  // ─────────────────────────────
  // STEP 2: Validate roster
  // ─────────────────────────────
  validateRoster: async (importId, compareRosterId = null) => {
  
    let url = `/validateRoster?import_id=${importId}`;

    if (compareRosterId) {
      url += `&roster_id=${compareRosterId}`;
    }
    const res = await apiClient.get(url);
    return res.data;
  },

  // ─────────────────────────────
  // DELETE / ABANDON IMPORT
  // ─────────────────────────────
  deleteRoster: async (importId) => {
    const res = await apiClient.delete(
      `/rosterProcessor?import_id=${importId}`,
    );
    return res.data;
  },

  getRosterImportStatus: async (importId) => {
    const res = await apiClient.get(
      `/rosterProcessor?import_id=${encodeURIComponent(importId)}`,
    );
    return res.data;
  },

  getImportRostersHistory: async () => {
    const res = await apiClient.get(`/listRoster`);
    return res.data;
  },
};
